function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "24",
  height: "24",
  rx: "3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.674 17.784L12 13.46l4.326 4.325a.941.941 0 101.33-1.33l-4.325-4.326 4.326-4.326a.941.941 0 00-1.331-1.331L12 10.797 7.674 6.47a.941.941 0 10-1.33 1.33l4.325 4.327-4.326 4.325a.941.941 0 001.331 1.331z",
  fill: "#54585D"
}))));